import { Component, OnInit, OnChanges, ElementRef, Input, SimpleChanges } from '@angular/core';
import { NotificationAlert } from '../../models/notificationAlert.model';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnChanges {

  @Input() alert: NotificationAlert;
  alertDOM: any;


  constructor(element: ElementRef) {
    this.alertDOM = element.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.alertDOM && this.alert) {
      window.scrollTo(0, this.alertDOM.offsetTop - 120);
    }
  }


  ngOnInit(): void {
  }


}
